import axios from 'axios';
import environment from '../config/environment';

class PostgreSQLAnalyticsService {
  constructor() {
    this.env = environment();
    
    // Set the base URL for API calls
    this.baseUrl = '/api';
    
    // Analytics endpoints
    this.endpoints = {
      connection: `${this.baseUrl}/analytics/postgresql/connection`,
      databases: `${this.baseUrl}/analytics/postgresql/databases`,
      test: `${this.baseUrl}/analytics/postgresql/test`
    };
    
    // Connection state
    this.connectionState = {
      status: 'disconnected',
      lastChecked: null,
      error: null
    };
    
    // Debug mode
    this.debug = true;
  }
  
  // Log helper
  log(...args) {
    if (this.debug) {
      console.log('[PostgreSQLAnalyticsService]', ...args);
    }
  }
  
  // Error log helper
  logError(...args) {
    console.error('[PostgreSQLAnalyticsService]', ...args);
  }
  
  // Check connection
  async checkConnection() {
    this.log('Checking PostgreSQL connection...');
    try {
      const response = await axios.get(this.endpoints.connection);
      this.log('Connection response:', response.data);
      
      this.connectionState = {
        status: 'connected',
        lastChecked: new Date(),
        error: null
      };
      
      return response.data;
    } catch (error) {
      this.logError('Connection error:', error);
      
      this.connectionState = {
        status: 'error',
        lastChecked: new Date(),
        error: error.response?.data?.error || error.message
      };
      
      return {
        status: 'error',
        connectionState: this.connectionState,
        databases: [],
        totalDatabases: 0,
        totalSize: '0 B',
        activeConnections: 0,
        timestamp: new Date().toISOString(),
        diagnostics: error.response?.data?.diagnostics || {
          message: 'Could not connect to PostgreSQL analytics endpoint'
        }
      };
    }
  }
  
  // Get PostgreSQL analytics data
  async getPostgreSQLAnalytics() {
    this.log('Fetching PostgreSQL analytics data...');
    return this.checkConnection();
  }
  
  // Get database details
  async getDatabaseDetails(databaseName) {
    this.log(`Fetching details for database: ${databaseName}`);
    try {
      const response = await axios.get(`${this.endpoints.databases}/${databaseName}`);
      return response.data;
    } catch (error) {
      this.logError(`Error fetching details for database ${databaseName}:`, error);
      throw error;
    }
  }
}

// Create and export singleton instance
const postgreSQLAnalyticsService = new PostgreSQLAnalyticsService();
export default postgreSQLAnalyticsService; 